import { successNotification } from 'notifications';

export const copyToClipboard = (text: string, message?: string, showToast = true) =>
  navigator.clipboard.writeText(text).then(() => {
    if (showToast) {
      successNotification(message || 'Copied to clipboard', { autoClose: 1500 });
    }
  });
